import { render, staticRenderFns } from "./EventOptions.vue?vue&type=template&id=489d3a89&scoped=true&"
import script from "./EventOptions.vue?vue&type=script&lang=js&"
export * from "./EventOptions.vue?vue&type=script&lang=js&"
import style0 from "./EventOptions.vue?vue&type=style&index=0&id=489d3a89&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489d3a89",
  null
  
)

export default component.exports